import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeTree: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCodeTree"><Path fillRule="evenodd" clipRule="evenodd" d="M6 8.5H13.1455C13.5758 7.05434 14.9145 6 16.5 6C18.433 6 20 7.567 20 9.5C20 11.433 18.433 13 16.5 13C14.9145 13 13.5758 11.9457 13.1455 10.5H6V16.5H13.1455C13.5758 15.0543 14.9145 14 16.5 14C18.433 14 20 15.567 20 17.5C20 19.433 18.433 21 16.5 21C14.9145 21 13.5758 19.9457 13.1455 18.5H4V3H6V8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCodeTree;
